<af-main-container [title]="'i18n_af_knowledgeBase' | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false"
                   [enableScroll]="false">
    <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        @if (activeTab === 'tabFaq' && hasAddButton) {
            <ui-kit-button
                type="primary"
                [label]="'i18n_af_buttonAddFaqQuestion' | translate"
                (clickListener)="addQuestion()"/>
        }
        @if (activeTab === 'tabDocuments' && isAdmin) {
            <ui-kit-button
                type="secondary"
                [label]="'i18n_af_knowledgeBaseArchive' | translate"
                (clickListener)="navigateToArchive()"/>
            @if (hasAddButton) {
                <ui-kit-button
                    type="primary"
                    [label]="'i18n_af_buttonAddFile' | translate"
                    (clickListener)="addDocument()"/>
            }
        }
    </div>
    <mat-tab-group mat-align-tabs="start"
                   animationDuration="0"
                   class="mt-16 w-100 h-100 hide-scroll-bar"
                   [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="handleNavigation($event)">
        @for (tab of tabs; track tab) {
            <mat-tab [label]="'i18n_af_' + tab | translate">
                <ng-template matTabContent>
                    @if (tab === 'tabFaq') {
                        <af-faq-tab (hasDataListener)="onHasData($event)"
                                    (addQuestionClickListener)="addQuestion()"/>
                    }
                    @if (tab === 'tabDocuments') {
                        <af-knowledge-base-documents-tab (hasDataListener)="onHasData($event)"
                                                         (addDocumentClickListener)="addDocument()"/>
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</af-main-container>
